import { render, staticRenderFns } from "./ProductGroupsEdit.vue?vue&type=template&id=095e3c5f&scoped=true"
import script from "./ProductGroupsEdit.vue?vue&type=script&lang=ts"
export * from "./ProductGroupsEdit.vue?vue&type=script&lang=ts"
import style0 from "./ProductGroupsEdit.vue?vue&type=style&index=0&id=095e3c5f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095e3c5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('095e3c5f')) {
      api.createRecord('095e3c5f', component.options)
    } else {
      api.reload('095e3c5f', component.options)
    }
    module.hot.accept("./ProductGroupsEdit.vue?vue&type=template&id=095e3c5f&scoped=true", function () {
      api.rerender('095e3c5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product-group/ProductGroupsEdit.vue"
export default component.exports